<template>
    <v-snackbar
        v-model="$store.state.snackbar.show"
        :timeout="timeout"
        :color="$store.state.snackbar.color"
        outlined
        text
        bottom
    >
        {{$store.state.snackbar.message}}
        <template v-slot:action="{ attrs }">
            <v-btn
                :color="$store.state.snackbar.color"
                icon
                x-small
                v-bind="attrs"
                @click="$store.commit('closeSnackbarMessage')"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    name: "Snackbar",

    computed: {
        timeout() {
            return this.$store.state.snackbar.color === "error"
                ? -1
                : 4500;
        },
    },
}
</script>

<style scoped>

</style>
